import { Roles } from '@/core/types';
import useAuth from '@/shared/context/auth-context';
import { FunctionComponent, ReactElement, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface RolesGuardProps {
	roles: Roles[];
	element: ReactNode;
}

const RolesGuard: FunctionComponent<RolesGuardProps> = ({ roles, element }): ReactElement => {
	const { user } = useAuth();

	if (!roles.includes(user!.role)) {
		return <Navigate to={'/'} replace />;
	}

	return <>{element}</>;
};

export default RolesGuard;
